export interface RootStateI {
  sidebar: boolean;
}

export const state: RootStateI = {
  sidebar: false,
};
